export default __webpack_public_path__ + "static/media/Astro_Jupiter_White.03782d0b.png";